import {useState, useMemo} from 'react';
import * as S from './BookNowPayLaterHoverPersuasion.styles';
import ReserverNowPayLaterIcon from '../../../../../Icons/ReserveNowPayLater';
import HotelIcon from '../../../../../Icons/HotelIcon';
import {defaultTheme} from '@stencil/build-theme/src/build-theme';
import GoBefikarIcon from '../../../../../Icons/GoBefikarIcon';
import {bnplInfo} from '@stencil/hotels-config/src';

const BookNowPayLaterHoverUI = ({direction, bnplData, customDisplay, checkinTime, bnplText}) => {
  const dIf = {txt: '', col: ''};
  const getTimeLineView = (index, timeLineLastIndex) => {
    if (index === 0)
      return (
        <S.BookNowPayLaterIconWrap>
          <ReserverNowPayLaterIcon
            fill={defaultTheme.colors.goWhite.base}
            width="2rem"
            height="2rem"
          />
        </S.BookNowPayLaterIconWrap>
      );

    if (index === timeLineLastIndex)
      return (
        <S.HotelIconWrap>
          <HotelIcon fill={defaultTheme.colors.goWhite.base} width="1.5rem" height="1.5rem" />
        </S.HotelIconWrap>
      );

    if (index === timeLineLastIndex - 1) return <S.CircularLineIndicator />;

    return <S.HorizontalStepMarker />;
  };

  const timeLineViewHTML = useMemo(() => {
    const isCheckInRange = checkinTime?.includes('-');
    const checkInText = isCheckInRange
      ? `Check-in begins from ${checkinTime}`
      : `Check-in Begins at ${checkinTime}`;
    let checkinDateTpl =
      bnplData?.cancellationDate == bnplData?.checkInDate
        ? [
            {
              if1: {
                txt: bnplData?.cancellationDate,
              },
              if2: {
                txt: checkInText,
              },
              if3: {
                txt: 'Non refundable after this date',
                col: '#E35439',
              },
            },
          ]
        : [
            {
              if1: {
                txt: bnplData?.cancellationDate,
              },
              if2: {
                txt: `Free cancellation till ${bnplData?.cancellationDate}`,
              },
              if3: {
                txt: 'Non refundable after this date',
                col: '#E35439',
              },
            },
            {
              if1: {
                txt: bnplData?.checkInDate,
              },
              if2: {
                txt: checkInText,
              },
            },
          ];
    const formattedData = [
      {
        if1: {
          txt: 'Book Today',
        },
        if2: {
          txt: 'using any payment option',
        },
      },
      {
        if1: {
          txt: bnplData?.cardChargeDate,
        },
        if2: {
          txt: 'Pay the remaining amount to avoid auto cancellation',
        },
      },
      ...checkinDateTpl,
    ];
    const value = formattedData?.map(({if1 = dIf, if2 = dIf, if3 = dIf}, index) => {
      return (
        <S.StepIndicatorWrap>
          {getTimeLineView(index, formattedData?.length - 1)}
          {if1?.txt && (
            <S.BookNowPayLaterStepsHeader customColor={if1?.col}>
              {if1?.txt}
            </S.BookNowPayLaterStepsHeader>
          )}
          {if2?.txt && (
            <S.BookTodayCondition customColor={if2?.col}>{if2?.txt}</S.BookTodayCondition>
          )}
          {if3?.txt && (
            <S.BookTodayChargesCondition customColor={if3?.col}>
              {if3?.txt}
            </S.BookTodayChargesCondition>
          )}
        </S.StepIndicatorWrap>
      );
    });

    return value;
  }, [bnplData]);

  return (
    <S.BookNowPayLaterHoverOuterWrap style={getStyles(direction)} customDisplay={customDisplay}>
      <S.TipPositioning />
      <S.BookNowPayLaterHoverHeaderWrap>
        <S.BookNowPayLaterHoverInnerHeaderWrap>
          <ReserverNowPayLaterIcon
            fill={defaultTheme.colors.goTeal.dark}
            width="2rem"
            height="2rem"
          />
          <S.BookNowPayLaterHoverText>{bnplText}</S.BookNowPayLaterHoverText>
        </S.BookNowPayLaterHoverInnerHeaderWrap>
        <GoBefikarIcon />
      </S.BookNowPayLaterHoverHeaderWrap>

      <S.BookNowPayLaterStepsOuterWrap>
        <div>{timeLineViewHTML}</div>
      </S.BookNowPayLaterStepsOuterWrap>
    </S.BookNowPayLaterHoverOuterWrap>
  );
};

const BookNowPayLaterHover: React.FC<{
  direction: string;
  cancellationTimeline: object;
  checkinTime: string;
  enableHover: boolean;
  bnplText?: string;
}> = ({children, direction, cancellationTimeline, enableHover = false, checkinTime, bnplText}) => {
  const [open, setOpen] = useState(false);

  return (
    <S.BookNowPayLaterHoverWrapper>
      <span onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
        {children}
      </span>
      {enableHover && (
        <BookNowPayLaterHoverUI
          direction={direction}
          bnplData={cancellationTimeline}
          checkinTime={checkinTime}
          customDisplay={open ? 'block' : 'none'}
          bnplText={bnplText}
        />
      )}
    </S.BookNowPayLaterHoverWrapper>
  );
};

const getStyles = direction => {
  switch (direction) {
    case 'right':
      return {
        left: '105%',
        transform: 'translateY(-50%)',
        top: '50%',
      };
    case 'left':
      return {
        right: '105%',
        transform: 'translateY(-50%)',
        top: '50%',
      };
    default:
      return {
        left: '105%',
        transform: 'translateY(-50%)',
        top: '50%',
      };
  }
};

export default BookNowPayLaterHover;
